<template>
<div class="productBuyWrapper">
  <div
    class="productBuy"
    v-for="(item,i) in pageCart"
    :key="i">
    <div class="product">
      <div class="confirmBox">
        <div class="confirm">
          <h3>是否確定刪除?</h3>
          <div class="btnWrapper">
            <button @click="delItem(item)"></button>
          </div>
          <div class="btnWrapper">
            <button @click="closeConfirmBox(i)"></button>
          </div>
        </div>
      </div>
      <div class="imgWrapper"><img :src="item.imageurl" alt=""></div>
      <article>
        <h3>{{item.name}}</h3>
        <div class="num">x {{item.qty}}</div>
        <div class="btnWrapper"><button @click="popDel(i)">刪除</button></div>
      </article>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "productBuy",
  data() {
    return {
      pageCart: [],
      noGift: []
    }
  },
  props: {
    cartList: {
      type: Array,
      default: () => []
    },
    pageNow: {
      type: Number,
      default: 1
    }
  },
  created() {
    this.cartList.forEach(list => {
      if (list.ptype != 4) {
        this.noGift.push(list)
      }
    })
    this.pageCart = []

    for (let i = 0; i < this.noGift.length; i++) {
      if (this.pageCart.length == 5) {
        return
      }
      this.pageCart.push(this.noGift[i])
    }
  },
  watch: {
    pageNow() {
      this.pageCart = []
      let startIndex = (this.pageNow - 1) * 5
      for (let i = startIndex; i < this.noGift.length; i++) {
        if (this.pageCart.length == 5) {
          return
        }
        this.pageCart.push(this.noGift[i])
      }
    },
    cartList() {
      this.pageCart = []
      this.noGift = []
      this.cartList.forEach(list => {
        if (list.ptype != 4) {
          this.noGift.push(list)
        }
      })
      if (this.cartList.length == 0) {
        return
      }
      let startIndex = '';
      // 判斷是否刪除了下一頁的唯一一項,刪除後,少一頁
      if ((this.noGift.length) % 5 == 0) {
        if (this.pageNow == 1) {
          startIndex = 0
        } else {
          this.$emit('passPageNow', this.pageNow - 1)
          startIndex = (this.pageNow - 1) * 5
        }
      } else {
        startIndex = (this.pageNow - 1) * 5
      }
      for (let i = startIndex; i < this.noGift.length; i++) {
        if (this.pageCart.length == 5) {
          return
        }
        this.pageCart.push(this.noGift[i])
      }

    }
  },
  methods: {
    popDel(e) {
      const productBuyAry = [...document.querySelectorAll('.productBuy')];
      productBuyAry.forEach(confirmBox => {
        confirmBox.children[0].children[0].style.display = 'none';
      })
      productBuyAry[e].children[0].children[0].style.display = 'block';
      this.confirmBox = true
    },
    closeConfirmBox(e) {
      const productBuyAry = [...document.querySelectorAll('.productBuy')];
      productBuyAry[e].children[0].children[0].style.display = 'none'
    },
    delItem(v) {
      const ticket = this.ec.getTicket()
      let delpd = {
        cartid: v.cartid,
        carttype: v.carttype,
        cid: v.cid,
        pid: v.pid,
        ptype: v.ptype,
        specid: v.specid
      }
      delpd = JSON.stringify(delpd)
      if (ticket) {
        this.axios.delete('shoppingcart', {
          data: delpd,
          headers: {
            'authorization': 'Bearer' + ticket,
            'Content-Type': 'application/json',
          }
        }).then(res => {
          const data = res.data.response
          if (data.status == 'OK') {
            const productBuyAry = [...document.querySelectorAll('.productBuy')];
            productBuyAry.forEach(confirmBox => {
              confirmBox.children[0].children[0].style.display = 'none';
            })
            // console.log("刪除購物明細完成");
            this.$emit('deleteCart')
          }
        })
      }
    }
  }
}
</script>  

<style lang="scss" scoped>
.productBuyWrapper {
  display: flex;

  @media(max-width:768px) {
    display: block;
  }
}

.productBuy {
  position: relative;
  width: 20%;
  min-width: 180px;
  margin: 0;
  padding: 10px;
  height: 270px;
  cursor: pointer;
  border-radius: 10px;
  transition: .3s;
  overflow: hidden;
  box-sizing: border-box;

  @media(max-width:768px) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    margin: 10px 0;
    height: 80px;
  }

  .product {
    @media(max-width:768px) {
      width: 100%;
      display: flex;
    }
  }

  .imgWrapper {
    width: auto;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    background: none;
    max-width: 160px;
    margin: 0 auto;

    @media(max-width:768px) {
      width: 25%;
      max-width: 80px;
      // max-height: 80px;
    }

    img {
      width: 100%
    }
  }

  article {
    @media(max-width:768px) {
      width: calc(100% - 80px);
      margin: 0;
      padding-left: 10px;
      box-sizing: border-box;
      position: relative;
    }

    h3 {
      margin: 5px 0 0;
    }

    h3,
    .num {
      font-size: .875rem;

      @media(max-width:768px) {
        margin: 0;
      }

    }

    .btnWrapper {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;

      @media(max-width:768px) {
        text-align: right;
      }

      button {
        border: 1px solid #3c3c3c;
        color: #3c3c3c;
        background-color: transparent;
        width: 100px;
        padding: 3px 0;
        border-radius: 10px;

      }
    }
  }

  &:hover {
    background-color: #f4f4f4;
  }

  .confirmBox {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;

    .confirm {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translateY(-50%);

      @media(max-width:768px) {
        display: flex;
        align-items: center;
      }

      h3 {
        text-align: center;
        font-size: 1rem;
        color: #fff;
        margin-bottom: 26px;

        @media(max-width:768px) {
          margin: 0;
          width: 40%;
        }
      }

      .btnWrapper {
        text-align: center;

        @media(max-width:768px) {
          margin: 0;
          width: 30%;
        }

        button {
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          width: 90px;
          height: 32px;

          @media(max-width:375px) {
            max-width: 60px;
          }

        }

        &:first-of-type {
          button {
            margin-bottom: 20px;
            background-image: url('data:image/png;base64,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');

            @media(max-width:768px) {
              margin: 0;
            }
          }
        }

        &:last-of-type {
          button {
            background-image: url('data:image/png;base64,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');

          }
        }

      }
    }
  }
}
</style>
